/* Espace Pro — Combine Home
 * Dashboard copy button. Form logic removed (existing form at /pages/professionals
 * feeds pro_applications via the CRM lead.js bridge).
 */

(function () {
  'use strict';

  const _lang = (document.documentElement.lang || '').toLowerCase();
  const _alertFallback = _lang.indexOf('pt') === 0
    ? 'Não foi possível copiar automaticamente — copie o código manualmente.'
    : _lang.indexOf('fr') === 0
      ? 'Impossible de copier automatiquement — veuillez copier le code manuellement.'
      : 'Could not copy automatically — please copy the code manually.';

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ep-code-card__copy');
    if (!btn) return;
    const code = btn.getAttribute('data-code') || '';
    if (!code) return;
    navigator.clipboard.writeText(code).then(() => {
      btn.classList.add('is-copied');
      const original = btn.getAttribute('data-label') || 'Copy';
      const copiedLabel = btn.getAttribute('data-label-copied') || 'Copied';
      btn.textContent = copiedLabel;
      setTimeout(() => { btn.classList.remove('is-copied'); btn.textContent = original; }, 2000);
    }).catch(() => alert(_alertFallback));
  });
})();
